import { VhvCard } from "@vhv/ui-kit-react";
import styles from "./forbidden.module.scss";
import React from "react";
import { MessageHelper } from "../../helpers/MessageHelper";
export const ForbiddenPage = () => {
    return React.createElement("div", { className: styles.mainContainer },
        React.createElement(VhvCard, { className: styles.forbiddenContainer },
            React.createElement(MessageHelper, { msgKey: "needAccessRights" })));
};
